'use client'

import { useTranslations } from 'next-intl'

import { TEvent } from '@/entities/campaign'
import { Link } from '@/shared/i18n'
import { isNilOrEmptyString } from '@/shared/lib'
import {
  TextButton,
  Image,
  MobileLayout,
  getExternalImageURL,
} from '@/shared/ui'

import { MobileCarousel } from '../carousel'

type Props = {
  events: Pick<TEvent, 'id' | 'landingPageCode' | 'title' | 'image' | 'link'>[]
}

export const MobileEvents = ({ events }: Props) => {
  const t = useTranslations('main.event')

  if (events.length === 0) return null

  const bannerLoader = ({ src }: { src: string }) => {
    return getExternalImageURL({
      src,
    })
  }

  return (
    <section className="bg-white">
      <MobileLayout className="flex flex-row items-center justify-between pb-6">
        <h3 className="typo-headline3 font-bold text-black">{t('title')}</h3>
        <TextButton size="small" color="gray" asChild>
          <Link href="/guest/campaign/event">{t('button.view_all')}</Link>
        </TextButton>
      </MobileLayout>

      <div className="mb-17.5">
        <MobileCarousel.Root useAutoPlay>
          {events.map(({ id, landingPageCode, title, image, link }) => {
            const hasCode = !isNilOrEmptyString(landingPageCode)

            const href = hasCode
              ? `/guest/campaign/event/${landingPageCode}`
              : link

            return (
              <MobileCarousel.Item key={id} className="pl-2">
                <Link href={href}>
                  <Image
                    src={image}
                    alt={title}
                    width={284}
                    height={96}
                    unoptimized
                    placeholder
                    loader={bannerLoader}
                    className="rounded-lg"
                  />
                </Link>
              </MobileCarousel.Item>
            )
          })}
        </MobileCarousel.Root>
      </div>
    </section>
  )
}
